@file:OptIn(InternalResourceApi::class)

package manyverse.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/manyverse.shared.generated.resources/"

@delegate:ResourceContentHash(121_594_976)
internal val Res.string.universe_module_announcement: StringResource by lazy {
      StringResource("string:universe_module_announcement", "universe_module_announcement", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44494, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39806, 56),
      ))
    }

@delegate:ResourceContentHash(1_626_849_088)
internal val Res.string.universe_module_combat: StringResource by lazy {
      StringResource("string:universe_module_combat", "universe_module_combat", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44543, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39863, 38),
      ))
    }

@delegate:ResourceContentHash(559_803_712)
internal val Res.string.universe_module_digicode: StringResource by lazy {
      StringResource("string:universe_module_digicode", "universe_module_digicode", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44582, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39902, 44),
      ))
    }

@delegate:ResourceContentHash(332_203_767)
internal val Res.string.universe_module_gm_timer: StringResource by lazy {
      StringResource("string:universe_module_gm_timer", "universe_module_gm_timer", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44627, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39947, 44),
      ))
    }

@delegate:ResourceContentHash(489_668_657)
internal val Res.string.universe_module_lockpicking: StringResource by lazy {
      StringResource("string:universe_module_lockpicking", "universe_module_lockpicking", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44676, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39992, 51),
      ))
    }

@delegate:ResourceContentHash(-157_767_191)
internal val Res.string.universe_module_timer: StringResource by lazy {
      StringResource("string:universe_module_timer", "universe_module_timer", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44728, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40044, 37),
      ))
    }

@delegate:ResourceContentHash(8_403_761)
internal val Res.string.universe_module_whiteboard: StringResource by lazy {
      StringResource("string:universe_module_whiteboard", "universe_module_whiteboard", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44770, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40082, 50),
      ))
    }

@delegate:ResourceContentHash(-1_037_055_488)
internal val Res.string.universe_modules_section: StringResource by lazy {
      StringResource("string:universe_modules_section", "universe_modules_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44825, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40133, 44),
      ))
    }

@delegate:ResourceContentHash(-1_355_132_374)
internal val Res.string.universe_name_label: StringResource by lazy {
      StringResource("string:universe_name_label", "universe_name_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44870, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40178, 47),
      ))
    }

@delegate:ResourceContentHash(-1_559_686_636)
internal val Res.string.universe_name_too_long: StringResource by lazy {
      StringResource("string:universe_name_too_long", "universe_name_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44922, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40226, 58),
      ))
    }

@delegate:ResourceContentHash(-1_781_871_894)
internal val Res.string.universe_no_custom_yet: StringResource by lazy {
      StringResource("string:universe_no_custom_yet", "universe_no_custom_yet", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44985, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40285, 82),
      ))
    }

@delegate:ResourceContentHash(1_994_826_245)
internal val Res.string.universe_save: StringResource by lazy {
      StringResource("string:universe_save", "universe_save", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45072, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40368, 29),
      ))
    }

@delegate:ResourceContentHash(776_083_591)
internal val Res.string.universe_theme_image_hint: StringResource by lazy {
      StringResource("string:universe_theme_image_hint", "universe_theme_image_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45110, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40398, 117),
      ))
    }

@delegate:ResourceContentHash(-883_305_256)
internal val Res.string.universe_theme_pick_image: StringResource by lazy {
      StringResource("string:universe_theme_pick_image", "universe_theme_pick_image", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45240, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40516, 53),
      ))
    }

@delegate:ResourceContentHash(-2_025_370_577)
internal val Res.string.universe_theme_preview_dark: StringResource by lazy {
      StringResource("string:universe_theme_preview_dark", "universe_theme_preview_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45298, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40570, 43),
      ))
    }

@delegate:ResourceContentHash(919_175_404)
internal val Res.string.universe_theme_preview_light: StringResource by lazy {
      StringResource("string:universe_theme_preview_light", "universe_theme_preview_light", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45342, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40614, 44),
      ))
    }

@delegate:ResourceContentHash(160_319_698)
internal val Res.string.universe_theme_reset: StringResource by lazy {
      StringResource("string:universe_theme_reset", "universe_theme_reset", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45387, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40659, 36),
      ))
    }

@delegate:ResourceContentHash(859_452_380)
internal val Res.string.universe_theme_section: StringResource by lazy {
      StringResource("string:universe_theme_section", "universe_theme_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45436, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40696, 50),
      ))
    }

@delegate:ResourceContentHash(286_864_712)
internal val Res.string.upload_sound: StringResource by lazy {
      StringResource("string:upload_sound", "upload_sound", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45491, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40747, 36),
      ))
    }

@delegate:ResourceContentHash(105_279_982)
internal val Res.string.view_character_sheet: StringResource by lazy {
      StringResource("string:view_character_sheet", "view_character_sheet", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45532, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40784, 56),
      ))
    }

@delegate:ResourceContentHash(-887_905_528)
internal val Res.string.view_inventory: StringResource by lazy {
      StringResource("string:view_inventory", "view_inventory", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45581, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40841, 42),
      ))
    }

@delegate:ResourceContentHash(-1_666_244_207)
internal val Res.string.view_notes: StringResource by lazy {
      StringResource("string:view_notes", "view_notes", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45628, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40884, 34),
      ))
    }

@delegate:ResourceContentHash(-1_832_369_860)
internal val Res.string.whiteboard_clear_all: StringResource by lazy {
      StringResource("string:whiteboard_clear_all", "whiteboard_clear_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45667, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40919, 40),
      ))
    }

@delegate:ResourceContentHash(-1_273_690_125)
internal val Res.string.whiteboard_close_for_all: StringResource by lazy {
      StringResource("string:whiteboard_close_for_all", "whiteboard_close_for_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45712, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40960, 52),
      ))
    }

@delegate:ResourceContentHash(1_411_132_670)
internal val Res.string.whiteboard_eraser: StringResource by lazy {
      StringResource("string:whiteboard_eraser", "whiteboard_eraser", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45769, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41013, 33),
      ))
    }

@delegate:ResourceContentHash(-45_073_192)
internal val Res.string.whiteboard_minimize: StringResource by lazy {
      StringResource("string:whiteboard_minimize", "whiteboard_minimize", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45803, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41047, 39),
      ))
    }

@delegate:ResourceContentHash(-1_893_647_300)
internal val Res.string.whiteboard_open: StringResource by lazy {
      StringResource("string:whiteboard_open", "whiteboard_open", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45905, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41137, 31),
      ))
    }

@delegate:ResourceContentHash(-2_019_174_813)
internal val Res.string.whiteboard_open_title: StringResource by lazy {
      StringResource("string:whiteboard_open_title", "whiteboard_open_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45843, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41087, 49),
      ))
    }

@delegate:ResourceContentHash(1_047_689_158)
internal val Res.string.whiteboard_pen: StringResource by lazy {
      StringResource("string:whiteboard_pen", "whiteboard_pen", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45937, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41169, 26),
      ))
    }

@delegate:ResourceContentHash(-347_816_826)
internal val Res.string.whiteboard_restore: StringResource by lazy {
      StringResource("string:whiteboard_restore", "whiteboard_restore", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45968, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41196, 50),
      ))
    }

@delegate:ResourceContentHash(-1_654_536_918)
internal val Res.string.whiteboard_show_grid_option: StringResource by lazy {
      StringResource("string:whiteboard_show_grid_option", "whiteboard_show_grid_option", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46031, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41247, 47),
      ))
    }

@delegate:ResourceContentHash(-1_819_053_266)
internal val Res.string.whiteboard_toggle_grid: StringResource by lazy {
      StringResource("string:whiteboard_toggle_grid", "whiteboard_toggle_grid", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46091, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41295, 38),
      ))
    }

@delegate:ResourceContentHash(1_594_558_795)
internal val Res.string.your_character: StringResource by lazy {
      StringResource("string:your_character", "your_character", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46130, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41334, 42),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString5Resources(map: MutableMap<String, StringResource>) {
  map.put("universe_module_announcement", Res.string.universe_module_announcement)
  map.put("universe_module_combat", Res.string.universe_module_combat)
  map.put("universe_module_digicode", Res.string.universe_module_digicode)
  map.put("universe_module_gm_timer", Res.string.universe_module_gm_timer)
  map.put("universe_module_lockpicking", Res.string.universe_module_lockpicking)
  map.put("universe_module_timer", Res.string.universe_module_timer)
  map.put("universe_module_whiteboard", Res.string.universe_module_whiteboard)
  map.put("universe_modules_section", Res.string.universe_modules_section)
  map.put("universe_name_label", Res.string.universe_name_label)
  map.put("universe_name_too_long", Res.string.universe_name_too_long)
  map.put("universe_no_custom_yet", Res.string.universe_no_custom_yet)
  map.put("universe_save", Res.string.universe_save)
  map.put("universe_theme_image_hint", Res.string.universe_theme_image_hint)
  map.put("universe_theme_pick_image", Res.string.universe_theme_pick_image)
  map.put("universe_theme_preview_dark", Res.string.universe_theme_preview_dark)
  map.put("universe_theme_preview_light", Res.string.universe_theme_preview_light)
  map.put("universe_theme_reset", Res.string.universe_theme_reset)
  map.put("universe_theme_section", Res.string.universe_theme_section)
  map.put("upload_sound", Res.string.upload_sound)
  map.put("view_character_sheet", Res.string.view_character_sheet)
  map.put("view_inventory", Res.string.view_inventory)
  map.put("view_notes", Res.string.view_notes)
  map.put("whiteboard_clear_all", Res.string.whiteboard_clear_all)
  map.put("whiteboard_close_for_all", Res.string.whiteboard_close_for_all)
  map.put("whiteboard_eraser", Res.string.whiteboard_eraser)
  map.put("whiteboard_minimize", Res.string.whiteboard_minimize)
  map.put("whiteboard_open", Res.string.whiteboard_open)
  map.put("whiteboard_open_title", Res.string.whiteboard_open_title)
  map.put("whiteboard_pen", Res.string.whiteboard_pen)
  map.put("whiteboard_restore", Res.string.whiteboard_restore)
  map.put("whiteboard_show_grid_option", Res.string.whiteboard_show_grid_option)
  map.put("whiteboard_toggle_grid", Res.string.whiteboard_toggle_grid)
  map.put("your_character", Res.string.your_character)
}
